import { IActivity } from 'app/shared/model/activity.model';

export interface IActivityHighlight {
  id?: number;
  highlightNote?: string | null;
  activity?: IActivity | null;
}

export const defaultValue: Readonly<IActivityHighlight> = {};
